import React, { FC, useState } from 'react';
import { ReactComponent as DeductAmountIcon } from 'assets/icons/empty-wallet-remove.svg';
import { BaseModal, Button, Input, Textarea, ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import { apiService } from 'utils/api';

interface DeductAmountModalType {
  show: boolean;
  onClose: () => void;
  riderId: string;
}

interface DeductAmountModalFooterType {
  onCancel: () => void;
  loading: boolean;
  onConfirm: () => void;
}

const DeductAmountModalFooter: FC<DeductAmountModalFooterType> = ({
  onCancel,
  onConfirm,
  loading
}) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const DeductAmountModal: FC<DeductAmountModalType> = ({ show, onClose, riderId }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const sendDetails = async () => {
    try {
      setLoading(true);
      await apiService.post(`logistics/super-admin/rider/${riderId}/register-deduction`, {
        data: {
          amount,
          note
        }
      });
      toast(<ToastMessage type='success' message='Deduction successful' />);
    } catch (error: any) {
      toast(<ToastMessage type='error' message={error.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  const [amount, setAmount] = useState(0);
  const [note, setNote] = useState('');
  return (
    <BaseModal
      isOpen={show}
      title='Deduct Amount'
      description='Any reason why you are deducting for this rider?'
      titleIcon={<DeductAmountIcon />}
      titleIconColor='danger'
      onRequestClose={onClose}
      footer={
        <DeductAmountModalFooter loading={loading} onCancel={onClose} onConfirm={sendDetails} />
      }>
      <div className='space-y-6'>
        <Input
          currency
          name='amount'
          label='Enter Amount'
          placeholder='amout'
          small
          onChange={(e) => setAmount(+e.target.value)}
          value={amount}
        />
        <div>
          <Textarea
            className='placeholder:text-[##A6A6A6] placeholder:font-normal'
            placeholder='Add a comment...'
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
          <p className='text-xs text-gray-5'>Word limit: 0/150</p>
        </div>
      </div>
    </BaseModal>
  );
};

export default DeductAmountModal;
